
import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceActionViewerDto extends EpimsBaseEntityDto {
   ActionTitle: string;
	 RegisterId: string;
	 ActionViewerId: string;
	 ActionDescription: string;
   Email: string;
	 Response: string;
	 Status: string;
}


